import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { data } from 'src/app/data';
import { environment } from 'src/environments/environment';
import { DirectionService } from '../../../shared/services/direction.service';

@Component({
    selector: 'app-block-slideshow',
    templateUrl: './block-slideshow.component.html',
    styleUrls: ['./block-slideshow.component.scss']
})
export class BlockSlideshowComponent {
    @Input() withDepartments = false;

    options = {
        nav: false,
        dots: true,
        loop: true,
        autoplay:true,
        responsive: {
            0: { items: 1 }
        },
        rtl: this.direction.isRTL()
    };
    currentWindowWidth;
    slides = [
        {
            contentshow:false,
            link:'/',
            titletext: 'Title',
            contenttext: 'Text',
            buttontext: 'Button',
            largeimage: 'assets/images/slides/slide-1-1110.jpg',
            mediumimage: 'assets/images/slides/slide-1-840.jpg',
            smallimage: 'assets/images/slides/slide-1-384.jpg'
        },
    ];

    environment = environment;
    constructor(
        public sanitizer: DomSanitizer,
        private direction: DirectionService
    ) {
        this.currentWindowWidth = window.screen.width;
        if (data.homeslider == undefined || data.homeslider == null) {
        }
        else {
            var slidesnew = [];
            for (let index = 0; index < data.homeslider.length; index++) {
                const slide = data.homeslider[index];
                var newslide = { ...slide };
                newslide.largeimage = this.environment.baseurl + newslide.largeimage;
                newslide.mediumimage = this.environment.baseurl + newslide.mediumimage;
                newslide.smallimage = this.environment.baseurl + newslide.smallimage;
                slidesnew.push(newslide);
            }
            this.slides = slidesnew;
        }
    }
}
